import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInfoBanner from '../reducers/info-banner.reducer';

export const getInfoBannerState = createFeatureSelector<fromInfoBanner.State>(
  fromInfoBanner.INFO_BANNER_FEATURE_KEY
);

export const getInfoBannerMessage = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.message
);

export const getInfoBannerVisibility = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.showBanner
);

export const getInfoBannerCloseText = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.closeButtonText
);

export const getInfoBannerCloseAction = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.closeButtonAction
);

export const getInfoBannerPrimaryText = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.primaryButtonText
);

export const getInfoBannerPrimaryAction = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.primaryButtonAction
);

export const getInfoBannerWithError = createSelector(
  getInfoBannerState,
  (state: fromInfoBanner.State) => state.showBannerWithError
);
